<div class="layout-row align-end gap-2px responsive-column container m-b-20">
  <div #buttonEdit class="in-block">
    <button
      mat-raised-button
      color="primary"
      (click)="editTask(); backupCheckValues()"
      *LOSxHasPermission="'UPDATE_PERMISSION'"
    >
      <fa-icon icon="edit" class="m-r-10"></fa-icon>
      {{ 'labels.buttons.Edit' | translate }}
    </button>
  </div>
</div>

<div class="container">
  <mat-card>
    <ng-container>
      <div class="layout-row">
        <div #mcTable class="layout-column flex-30">
          <mat-list>
            @for (grouping of groupings; track grouping) {
              <mat-list-item
                [ngClass]="selectedItem === grouping ? 'active' : 'inactive'"
                (click)="showPermissions(grouping)"
              >
                <span class="grouping-name">
                  {{ formatName(grouping) }}
                </span>
              </mat-list-item>
            }
          </mat-list>
        </div>

        <mat-divider [vertical]="true"></mat-divider>
        <div class="list-permission layout-column flex-70">
          <form [formGroup]="formGroup" (submit)="submit()">
            <div formArrayName="roster">
              @for (permission of permissions.permissions; track permission; let i = $index) {
                <div class="display-permissions">
                  <div [formGroupName]="i">
                    <mat-checkbox name="cp" id="{{ permission.code }}" formControlName="selected">
                      {{ permissionName(permission.code) }}
                    </mat-checkbox>
                  </div>
                </div>
              }
            </div>
          </form>
        </div>
      </div>
    </ng-container>

    @if (!isDisabled) {
      <div class="layout-row layout-align-center gap-5px layout-xs-column">
        <mat-card-actions>
          <button type="button" mat-raised-button (click)="cancel(); restoreCheckboxes()">
            {{ 'labels.buttons.Cancel' | translate }}
          </button>
          <button mat-raised-button color="primary" (click)="submit()" *LOSxHasPermission="'UPDATE_PERMISSION'">
            {{ 'labels.buttons.Submit' | translate }}
          </button>
        </mat-card-actions>
      </div>
    }
  </mat-card>
</div>

<ng-template #templateButtonEdit let-popover="popover">
  <h2>{{ 'labels.heading.Edit' | translate }}</h2>
  <p class="mw300">{{ 'labels.text.To add or remove a task from the Maker-Checker list' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); previousStep()">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="popover.close(); showPopover(templateMcTable, mcTable, 'top', true)"
    >
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateMcTable let-popover="popover">
  <h4 class="mw300">
    {{ 'labels.heading.List of all maker checker tasks' | translate }}:
    <a
      href="https://LOSforge.jira.com/wiki/spaces/docs/pages/67895359/Configure+Maker-Checker+Tasks"
      target="_blank"
      >{{ 'labels.inputs.Configure Maker-Checker Tasks' | translate }}</a
    >
  </h4>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="popover.close(); showPopover(templateButtonEdit, buttonEdit, 'bottom', true)"
    >
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStep()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>
